// extracted by mini-css-extract-plugin
export default {"profile-picture":"styles_profile-picture__yJCMO"};